import { app, Component, ojs } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import { either, extractNonObjectPairs, uniqueId } from "../../helpers";

const h = app("h");

export default class CheckYesno extends Component {
    name = "CheckYesno";
    render(config, ...args) {
        const inputAttrs = extractNonObjectPairs(config);
        const hook = `yn-${config?.uid ?? uniqueId()}`;
        const type = config?.type ?? "checkbox";
        const id = config?.id ?? hook;

        // The `checked` attr, if present, checks the <input>
        // regardless of its value. So we're removing it from
        // `inputAttrs` by default
        const checked = config?.checked ?? false;
        delete inputAttrs.checked;

        return h.label(
            { class: "check-yesno" },
            h.div(
                { class: "check-yesno-wrap", data_yn_wrapper: hook },
                h.input(
                    {
                        hidden: "hidden",
                        class: "check-yesno-input",
                        data_yn_input: hook,
                        type: type,
                        id: id,
                        listeners: {
                            change: function () {
                                dom.get(
                                    `[data-yn-wrapper=${hook}]`,
                                ).classList.toggle(
                                    "is-checked",
                                    dom.get(`[data-yn-input=${hook}]`).checked,
                                );
                            },
                        },
                        ...inputAttrs,
                    },
                    either(checked, { checked: true }),
                ),
                h.span({ class: "check-yesno-toggle" }),
            ),
            h.div(
                { class: "check-yesno-desc" },
                h.span(
                    {
                        class: [
                            "check-yesno-label",
                            config?.label?.gradient ? "text-gradient" : "",
                            config?.label?.bolder ? "fw-600" : "",
                            config?.label?.bold ? "fw-500" : "",
                        ].join(" "),
                    },
                    config?.label?.value ?? "Label",
                ),
                either(
                    config?.helpText?.value,
                    h.span(
                        {
                            class: [
                                "check-yesno-text",
                                config?.label?.bold ? "fw-500" : "",
                            ].join(" "),
                        },
                        config?.helpText?.value,
                    ),
                ),
            ),
            ...args,
        );
    }
}
